/**
 * @项目名称: work
 * @功能名称:
 * @文件名称: api
 * @Date: 2019/10/8
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
export default {
  YYB_DOWNLOAD_LINK: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xiaoying.cardloan',
  NEW_DOWNLOAD_LINK: 'https://cardloan.xiaoying.com/landing-h5/downloadApp/index.html'
}
